(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-parallel', actionParallel);

    function actionParallel(handleActionCall, $q, lodash) {
        return function(panel, options, actionData, responseModel) {
            const calls = options.actions.map(function(action) {
               return handleActionCall(action.name, action.options, actionData, panel, responseModel);
            });
            return $q.all(calls).then(function(res) {
               if (options.merge === true) {
                   return res.reduce(function(result, row) {
                       if (typeof row !== typeof {}) {
                           return result;
                       }
                       return lodash.merge({}, result, row);
                   }, {});
               }
               if (options.named) {
                   // the length of name must be equals to the length of calls, otherwise data will be lost.
                   return options.named.reduce(function(result, name, index) {
                       lodash.set(result, name, res[index]);
                       return result;
                   }, {});
               }
               return res;
            });
        };
    }
})();